var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransacciones(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_58_5",
    "data-name": "Componente 58 \\u2013 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_270",
    "data-name": "Rect\\xE1ngulo 270",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sync_alt_FILL0_wght300_GRAD0_opsz40",
    d: "M115.937-796.143l3.954,3.944a.925.925,0,0,1,.287.667.926.926,0,0,1-.295.682.93.93,0,0,1-.669.294.921.921,0,0,1-.679-.294l-5.415-5.415a1.155,1.155,0,0,1-.269-.395,1.207,1.207,0,0,1-.08-.441,1.2,1.2,0,0,1,.08-.446,1.171,1.171,0,0,1,.269-.39l5.44-5.44a.931.931,0,0,1,.663-.283.928.928,0,0,1,.685.283.95.95,0,0,1,.288.678.917.917,0,0,1-.288.668l-3.971,3.971h22.829a.93.93,0,0,1,.686.272.93.93,0,0,1,.272.686.93.93,0,0,1-.272.686.93.93,0,0,1-.686.272Zm21.658-12.51H114.766a.93.93,0,0,1-.686-.272.93.93,0,0,1-.272-.686.93.93,0,0,1,.272-.686.93.93,0,0,1,.686-.272H137.6l-3.969-3.969a.925.925,0,0,1-.287-.667.926.926,0,0,1,.295-.682.93.93,0,0,1,.669-.294.891.891,0,0,1,.669.294l5.44,5.44a1.241,1.241,0,0,1,.274.39,1.133,1.133,0,0,1,.085.445,1.109,1.109,0,0,1-.085.436,1.241,1.241,0,0,1-.274.39L135-803.361a.936.936,0,0,1-.668.283.9.9,0,0,1-.681-.283.934.934,0,0,1-.3-.678.934.934,0,0,1,.3-.678Z",
    transform: "translate(-110.771 819.18)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransacciones);
export default __webpack_public_path__ + "static/media/transacciones.2707faa9f92f24cb99aaadd5d57a1bf6.svg";
export { ForwardRef as ReactComponent };